<app-browser-header></app-browser-header>

<ion-content>
  <ion-grid class="page-container" fixed>
    <div class="page-title">{{ "CONTACT_US" | translate }}</div>

    <div class="options">
      <div class="option" tappable (click)="onSendFeedback()">
        <ion-icon class="option-icon" icon="/assets/custom-icons/customer-support.svg"></ion-icon>
        <p class="option-text">{{ "CONTACT_PAGE.SEND_FEEDBACK" | translate }}</p>
        <ion-icon class="option-arrow-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
      </div>
      <div class="option" tappable (click)="onCallUs()">
        <ion-icon class="option-icon" icon="/assets/custom-icons/phone.svg"></ion-icon>
        <p class="option-text">{{ "CALL_US" | translate }}</p>
        <ion-icon class="option-arrow-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
      </div>
      <div class="option" tappable (click)="onEmailUs()">
        <ion-icon class="option-icon" icon="/assets/custom-icons/at.svg"></ion-icon>
        <p class="option-text">{{ "EMAIL_US" | translate }}</p>
        <ion-icon class="option-arrow-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
      </div>
      <div *ngIf="isWhatsAppChatEnabled" class="option" tappable (click)="onTextUs()">
        <ion-icon class="option-icon live-chat-icon" icon="/assets/custom-icons/whatsapp.svg"></ion-icon>
        <p class="option-text">{{ "TEXT_US" | translate }}</p>
        <ion-icon class="option-arrow-icon" icon="/assets/custom-icons/b-angle-right.svg"></ion-icon>
      </div>
    </div>
  </ion-grid>

  <app-browser-footer></app-browser-footer>
</ion-content>
